import React, { useMemo } from 'react';
import { FaTimes, FaChartBar, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import styles from './ProjectStatsModal.module.css';

const ProjectStatsModal = ({ projects, onClose }) => {
  // Calculate statistics
  const stats = useMemo(() => {
    const phaseStats = {};
    const statusStats = {
      'Aktif': 0,
      'Pasif': 0
    };

    projects.forEach(project => {
      // Count by phase
      const phase = project.projectPhase || 'Belirtilmemiş';
      if (phase && phase !== '') {
        phaseStats[phase] = (phaseStats[phase] || 0) + 1;
      }

      // Count by status
      const status = project.projectStatus || 'Aktif';
      if (status === 'Aktif' || status === 'Pasif') {
        statusStats[status] = (statusStats[status] || 0) + 1;
      }
    });

    return { phaseStats, statusStats };
  }, [projects]);

  const totalProjects = projects.length;
  const activePercentage = totalProjects > 0 
    ? ((stats.statusStats['Aktif'] / totalProjects) * 100).toFixed(1)
    : 0;
  const passivePercentage = totalProjects > 0 
    ? ((stats.statusStats['Pasif'] / totalProjects) * 100).toFixed(1)
    : 0;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>
            <FaChartBar className={styles.titleIcon} />
            Proje İstatistikleri
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className={styles.modalBody}>
          {/* Summary Cards */}
          <div className={styles.summaryCards}>
            <div className={styles.summaryCard}>
              <div className={styles.cardLabel}>Toplam Proje</div>
              <div className={styles.cardValue}>{totalProjects}</div>
            </div>
            <div className={`${styles.summaryCard} ${styles.activeCard}`}>
              <FaCheckCircle className={styles.cardIcon} />
              <div className={styles.cardLabel}>Aktif Projeler</div>
              <div className={styles.cardValue}>{stats.statusStats['Aktif']}</div>
              <div className={styles.cardPercentage}>{activePercentage}%</div>
            </div>
            <div className={`${styles.summaryCard} ${styles.passiveCard}`}>
              <FaTimesCircle className={styles.cardIcon} />
              <div className={styles.cardLabel}>Pasif Projeler</div>
              <div className={styles.cardValue}>{stats.statusStats['Pasif']}</div>
              <div className={styles.cardPercentage}>{passivePercentage}%</div>
            </div>
          </div>

          {/* Status Chart */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Proje Durumu Dağılımı</h3>
            <div className={styles.chartContainer}>
              <div className={styles.barChart}>
                <div className={styles.barItem}>
                  <div className={styles.barLabel}>
                    <span className={styles.labelText}>Aktif</span>
                    <span className={styles.labelCount}>{stats.statusStats['Aktif']}</span>
                  </div>
                  <div className={styles.barWrapper}>
                    <div 
                      className={`${styles.bar} ${styles.barActive}`}
                      style={{ width: `${activePercentage}%` }}
                    >
                      <span className={styles.barPercentage}>{activePercentage}%</span>
                    </div>
                  </div>
                </div>
                <div className={styles.barItem}>
                  <div className={styles.barLabel}>
                    <span className={styles.labelText}>Pasif</span>
                    <span className={styles.labelCount}>{stats.statusStats['Pasif']}</span>
                  </div>
                  <div className={styles.barWrapper}>
                    <div 
                      className={`${styles.bar} ${styles.barPassive}`}
                      style={{ width: `${passivePercentage}%` }}
                    >
                      <span className={styles.barPercentage}>{passivePercentage}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Phase Statistics */}
          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>Proje Aşaması Dağılımı</h3>
            <div className={styles.statsGrid}>
              {Object.entries(stats.phaseStats)
                .sort((a, b) => b[1] - a[1])
                .map(([phase, count]) => {
                  const percentage = totalProjects > 0 
                    ? ((count / totalProjects) * 100).toFixed(1)
                    : 0;
                  return (
                    <div key={phase} className={styles.statCard}>
                      <div className={styles.statPhase}>{phase}</div>
                      <div className={styles.statCount}>{count}</div>
                      <div className={styles.statBar}>
                        <div 
                          className={styles.statBarFill}
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                      <div className={styles.statPercentage}>{percentage}%</div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.closeFooterButton} onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatsModal;
